import {
  ORDERLINE_TIMELINE_STEP_TYPE,
  type OrderlineTimelineStep,
  type StepType,
} from '~/api/my-orders/types/OrderlineTimeline.types'
import {
  type GetOrderlineStateEnum,
  ORDERLINE_STATE_ENUM,
} from '~/api/resolution-engine/types/Common.types'

type getActiveTimelineStepReturnValue = StepType | ''

export function getActiveTimelineStep({
  orderlineState,
  orderlineTimeline,
}: {
  orderlineState: GetOrderlineStateEnum
  orderlineTimeline: Array<OrderlineTimelineStep>
}): getActiveTimelineStepReturnValue {
  const activeStep = orderlineTimeline.find((item) => item.current)

  if (
    activeStep?.type === ORDERLINE_TIMELINE_STEP_TYPE.validation &&
    orderlineState === ORDERLINE_STATE_ENUM.shipped
  ) {
    return ORDERLINE_TIMELINE_STEP_TYPE.shipment
  }

  return activeStep?.type ? activeStep.type : ''
}
